module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-45.902198db.png";